import { render, staticRenderFns } from "./ProjectsWorkerItem.vue?vue&type=template&id=24d932ef"
import script from "./ProjectsWorkerItem.vue?vue&type=script&lang=js"
export * from "./ProjectsWorkerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports